module.exports = __webpack_public_path__ + "img/cooperative1_logo5.a06647e6.jpg";